<template>
    <div class="t_content_view">
        <el-button class="t_add_people" type="primary" color="#4F46E5" @click="addqd(1,'')" >新建渠道类别</el-button>
        <el-table :header-cell-style="{ background: '#F1F3F9' }" :data="tableData.data" style="width: 100%">
            <el-table-column prop="title" label="类别名称">
            </el-table-column>
            <el-table-column prop="created_by" label="创建人" />
             <el-table-column prop="description" label="类别说明" />
            <el-table-column prop="created_at" label="创建时间" />
            <el-table-column label="操作">
                <template #default="scope">
                    <el-button size="small" type="text" 
                    style="color:#4F46E5"
                    @click="addqd(2, scope.row)">编辑</el-button>
                    <el-button size="small" type="text" 
                    style="color:#4F46E5"
                    @click="handleDelete(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <!-- <pagechange :total="total" :nowpage="searchdata.pageNo" @page_change="page_change" /> -->
    </div>
    <el-dialog v-model="isaddqd" title="新增渠道类别" width="500px" >
        <el-form  label-width="120px">
            <el-form-item label="类别名称：">
                <el-input placeholder="请输入渠道类别" v-model="addlist.title"  clearable />
            </el-form-item>
            <el-form-item label="类别说明：">
                <el-input type="textarea" placeholder="请输入类别说明" v-model="addlist.description"  clearable />
            </el-form-item>
        </el-form>
        <div class="t_cz_box">
            <el-button @click="addrest" >取消</el-button>
            <el-button color="#4F46E5" @click="addsub" type="primary">确定</el-button>
        </div>
    </el-dialog>
</template>
<script setup>
import { ref, reactive, provide, onBeforeMount, onMounted, watch,inject } from 'vue'
import { qdtypelist,addqdtype,changeqdtype,delqdtype,neweaddqd,newqdlist,neweditqd,newdelqd } from '@/assets/js/common.js'
import { ElMessage,ElMessageBox } from 'element-plus'
//导入子组件
import pagechange from '../components/pagechange.vue'
//动态获取接口地址
const _url2 = inject('_url2')
onMounted(() => {
    console.log('onMounted')
    //获取列表数据
    getlist()
})
//列表数据
const tableData = reactive({
    data:[
        {
            qdname: '111',
            cjr: '111',
            typedesc:'111',
            ctime: '2022-05-30 15:41:50',
        }
    ]
})
//成员总数
// const total = ref(0)
//搜索
const searchdata = reactive({
   //当前页
    // pageNo:1,
    // pageSize:10
})
//获取列表数据
const getlist = ()=>{
    newqdlist(searchdata).then((response)=>{
        console.log(response)
        if (response.data.msg.code == 0) {
            tableData.data=response.data.data
            // total.value = response.data.result.total
        }
    })
}
//监听分页
// const page_change = (val)=>{
//     searchdata.pageNo = val
//     //人员列表
//     getlist()
// }
//新增字段
const addlist = reactive({
    id:'',
    title:'',
    description:''
})
//当前是新增还是编辑
const addtype=ref('')
//新增弹窗是否显示
const isaddqd = ref(false)
//点击新增渠道
const addqd = (type,row)=>{
    isaddqd.value=true
    addtype.value=type
    if(type==1){
        //新增
        addlist.id=''
        addlist.title=''
        addlist.description=''
    }else if(type==2){
        //编辑
        addlist.id=row.id
        addlist.title=row.title
        addlist.description=row.description
    }
    
}
//取消新增
const addrest = ()=>{
    isaddqd.value=false
}
//提交新增
const addsub = ()=>{
        if(addtype.value==1){
            neweaddqd(addlist).then((response)=>{
                if (response.data.msg.code == 0) {
                    ElMessage({
                        type: 'success',
                        message: '创建成功！',
                    })
                    isaddqd.value=false
                    getlist()
                }
            })
        }else{
            neweditqd(addlist).then((response)=>{
                if (response.data.msg.code == 0) {
                    ElMessage({
                        type: 'success',
                        message: '修改成功！',
                    })
                    isaddqd.value=false
                    getlist()
                }
            })
        }
}
//删除
const handleDelete = (id)=>{
    ElMessageBox.confirm(
    '是否确认删除?',
    '提示',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
        newdelqd({id:id}).then((response)=>{
            if (response.data.msg.code == 0) {
                ElMessage({
                    type: 'success',
                    message: '删除成功！',
                })
                getlist()
            }
        })
    })
    .catch(() => {
      ElMessage({
        type: 'info',
        message: '已取消',
      })
    })
}


</script>
<style scoped>


:deep( .el-input__wrapper) {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
:deep( .el-textarea__inner){
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}

.t_add_people {
    margin-top: 20px;
    margin-bottom: 20px;
}

.t_head_box {
    display: flex;
    align-items: center;
}

/* .t_content_view {
    padding: 20px;
} */
/* .t_cz_box{
    display: flex;
    justify-content:space-around
} */
</style>